<template>
  <div :id="id" class="v2026-overlay-card" :data-render-key="renderKey">
    <slot :dirty="renderKey"/>
  </div>
</template>

<script>
export default {
  name: 'overlay-card',
  props: {
    // bound to the root element so existing aria-controls / aria-labelledby targets keep resolving
    id: {
      type: String,
      default: null
    },
    // version2026: whether the card is currently shown. Drives the click-outside listener lifecycle —
    // attach a document mousedown listener while open, detach the moment it closes.
    open: {
      type: Boolean,
      default: false
    },
    // version2026: opt-out switch. When false the card never attaches the outside listener (stays
    // purely presentational). Default true so EVERY card using OverlayCard auto-closes on outside click.
    closeOnOutside: {
      type: Boolean,
      default: true
    },
    ignore: {
      default: null,
      validator: (v) => v == null || Array.isArray(v) || v instanceof Element
    },
    renderKey: {
      default: null
    }
  },
  watch: {
    // attach/detach the document listener as the card opens/closes
    open (isOpen) {
      this.syncOutsideListener(isOpen)
    }
  },
  mounted () {
    // honour an already-open card mounted in the open state
    this.syncOutsideListener(this.open)
  },
  beforeDestroy () {
    // never leave the listener attached
    document.removeEventListener('mousedown', this.onOutsideClick)
  },
  methods: {
    syncOutsideListener (isOpen) {
      if (isOpen && this.closeOnOutside) {
        document.addEventListener('mousedown', this.onOutsideClick)
      } else {
        document.removeEventListener('mousedown', this.onOutsideClick)
      }
    },
    // close when a mousedown lands outside BOTH the card root ($el) and any ignored element. Clicks
    // inside the card (checkboxes / pills / search input) or on an ignored trigger do nothing.
    onOutsideClick (e) {
      if (this.$el && this.$el.contains(e.target)) return
      const ignored = Array.isArray(this.ignore) ? this.ignore : [this.ignore]
      for (const el of ignored) {
        if (el && el.contains(e.target)) return
      }
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.v2026-overlay-card {
  position: absolute;
  z-index: 1050;
  min-width: 250px;
  background: #FFFFFF;
  border: 1px solid #EBEDF0;
  border-radius: 8px;
  box-shadow: 0px 0px 14px 0px #00000040;
  padding: 16px;
  overflow: visible;
}
</style>
